module.exports = __webpack_public_path__ + "img/curitibaebus1.f363acd0.png";